import React from 'react';
import { useLocation } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import * as constants from '../common/constants';
import { getLabelFromJspVariables } from '../common/JspUtil';
import { UserIcon } from './SvgIcon';

const menuItemSx = {
    fontSize: '11pt',
    color: '#212529',
    padding: '4px 16px',
    lineHeight: '1.3',
};

const UserMenu = ({
    authenticatedUser,
    isMemberLogin,
    onLogout,
    onMemberLogout,
    onNavigate,
}) => {
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (key) => {
        handleClose();
        switch (key) {
            case 'profile':
                onNavigate(constants.ROUTE_PAGE_PROFILE);
                break;
            case 'logout':
                if (isMemberLogin) {
                    onMemberLogout && onMemberLogout();
                } else {
                    onLogout && onLogout();
                }
                break;
            case '2fa':
                onNavigate(constants.ROUTE_PAGE_TFA_REGISTER);
                break;
            case 'password':
                onNavigate(constants.ROUTE_PAGE_CHANGE_PASSWORD);
                break;
            case 'userInfo':
                onNavigate(constants.ROUTE_PAGE_USERINFO);
                break;
            case 'webauthn':
                onNavigate(constants.ROUTE_PAGE_WEBAUTHNDEVICES);
                break;
            case 'changeEmail':
                onNavigate(constants.ROUTE_PAGE_CHANGE_EMAIL);
                break;
            default:
                break;
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton
                onClick={handleClick}
                size="small"
                aria-label="User menu"
                aria-controls={open ? 'user-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                data-automation-id="user_menu_btn"
            >
                <UserIcon />
            </IconButton>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'user-menu-button' }}
            >
                {location && location.pathname !== constants.ROUTE_PAGE_USERINFO && (
                    <MenuItem sx={menuItemSx} onClick={() => handleSelect('userInfo')}
                        data-automation-id="user_menu_applications_item">
                        {getLabelFromJspVariables('label_applications')}
                    </MenuItem>
                )}
                {location && location.pathname !== constants.ROUTE_PAGE_PROFILE && (
                    <MenuItem sx={menuItemSx} onClick={() => handleSelect('profile')}
                        data-automation-id="user_menu_update_contact_item">
                        {getLabelFromJspVariables('action_update_contact')}
                    </MenuItem>
                )}
                <MenuItem sx={menuItemSx} onClick={() => handleSelect('password')}
                    data-automation-id="user_menu_change_password_item">
                    {getLabelFromJspVariables('change_password')}
                </MenuItem>
                <MenuItem sx={menuItemSx} onClick={() => handleSelect('2fa')}
                    data-automation-id="user_menu_tfa_settings_item">
                    {getLabelFromJspVariables('label_tfa_settings_new_device')}
                </MenuItem>
                {authenticatedUser && authenticatedUser.authenticatedApp === 'GLOBAL' && (
                    <MenuItem sx={menuItemSx} onClick={() => handleSelect('changeEmail')}
                        data-automation-id="user_menu_change_email_item">
                        {getLabelFromJspVariables('title_change_global_email')}
                    </MenuItem>
                )}
                <Divider sx={{ margin: 0, padding: 0 }} />
                <MenuItem sx={menuItemSx} onClick={() => handleSelect('logout')}
                    data-automation-id="user_menu_logout_item">
                    {getLabelFromJspVariables('action_logout')}
                </MenuItem>
            </Menu>
        </div>
    );
};

export default UserMenu;
